import { Divider } from '@heroui/react';
import { formatValueAsString } from '../../../utils/helpers';

export type TMetricsCard = {
	label: string;
	value: number | string | undefined;
	suffix?: string;
};

interface IMetricsCardProps {
	metrics: TMetricsCard[];
	valueTextSize?: string;
	className?: string;
	minimumFractionDigits?: number;
	maximumFractionDigits?: number;
}
/**
 * MetricsCard component to display a list of metrics with labels and values.
 * @param {TMetricsCard[]} metrics - Array of metric objects containing label, value, and optional suffix.
 * @param {string} [valueTextSize] - Optional CSS class for the value text size.
 * @param {string} [className] - Optional additional CSS class for the card.
 * @param {number} [minimumFractionDigits] - Minimum number of fraction digits for formatting.
 * @param {number} [maximumFractionDigits] - Maximum number of fraction digits for formatting.
 */
const MetricsCard: React.FC<IMetricsCardProps> = ({
	metrics,
	valueTextSize,
	className = '',
	minimumFractionDigits = 1,
	maximumFractionDigits = 1,
}) => {
	const formatOptions = { minimumFractionDigits: minimumFractionDigits, maximumFractionDigits: maximumFractionDigits };

	return (
		<div className={`flex flex-col space-y-1 ${className}`}>
			{metrics.map((metric, index) => (
				<div key={index} className="flex">
					<Divider className="w-1 h-full mr-3 bg-msi-darkblue-color rounded" orientation="vertical" />
					<div>
						<p className="text-sm text-msi-darkgrey-color-400">{metric.label}</p>
						<p className={`${valueTextSize || 'text-3xl'} font-bold text-msi-darkgrey-color`}>
							{(!metric.value && '-') || typeof metric.value === 'number'
								? formatValueAsString(metric.value, formatOptions, '-', '', '')
								: metric.value}
							{metric.suffix}
						</p>
					</div>
				</div>
			))}
		</div>
	);
};

export default MetricsCard;
